import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import elementZhTWLocale from 'element-ui/lib/locale/lang/zh-TW'// element-ui lang

import ecoEnLocale from 'common-ui/src/locale/lang/en' // common-ui lang
import ecoZhLocale from 'common-ui/src/locale/lang/zh-CN'// common-ui lang
import ecoZhTWLocale from 'common-ui/src/locale/lang/zh-TW'// common-ui lang

import enLocale from './lang/en'
import zhLocale from './lang/zh-CN'
import zhTWLocale from './lang/zh-TW'

Vue.use(VueI18n)
const messages = {
  "en-US": {
    ...enLocale,
    ...elementEnLocale,
    ...ecoEnLocale,

  },
  "zh-CN": {
    ...zhLocale,
    ...elementZhLocale,
    ...ecoZhLocale
  },
  "zh-TW": {
    ...zhTWLocale,
    ...elementZhTWLocale,
    ...ecoZhTWLocale
  }
}

const i18n = new VueI18n({
  // set locale
  // options: en | zh 
  locale: localStorage.getItem("lang") || 'zh-CN',
  // set locale messages
  messages
})

export default i18n